
<div *ngIf="privilegesView==='AccessDenied'" class=" outside-container  mt-4" >
  <div class="box-container">
    <div class="container">
      <div *ngIf="privilegesView==='AccessDenied'" class="  d-flex justify-content-center" >

  <img src="../../../assets/images/AccessDeniedError.png" alt="">
</div>

 </div>
</div>
</div>

<div *ngIf="privilegesView==='VAMD'" class="outside-container mt-4">
    <div class="box-container ">
        <div class="container">
            <div class="title ">

              <div class="row">
                <div class=" col-md-2  " >
                  <div *ngIf="!ShowEdit" class="pointer d-flex justify-content-start "  (click)="backClick()" style="padding-left:20px;">⬅️</div>
                  <div *ngIf="ShowEdit" class="pointer d-flex justify-content-start "  (click)="back()" style="padding-left:20px;">⬅️</div>

                </div>  
               <div class="col-md-7 d-flex justify-content-center">Travel Policy</div>
               <div class=" col-md-3 row ">
                 <div class="d-flex justify-content-end">
                  <!-- <button *ngIf="showGroup" class="btn btn-outline-primary btn-sm " (click)="onAddGroup()"><img src="assets/images/Add_24.png"></button>
                  <button *ngIf="showSupplier" class="btn btn-outline-primary btn-sm " (click)="onAddSupplier()"><img src="assets/images/Add_24.png"></button>
                  <button  *ngIf="showSource" class="btn btn-outline-primary btn-sm " (click)="onAddSource()"><img src="assets/images/Add_24.png"></button>
                  <button  *ngIf="showCarrier" class="btn btn-outline-primary btn-sm " (click)="onAddCarrier()"><img src="assets/images/Add_24.png"></button> -->

               </div>
                </div>
              </div>
            
            </div> 
            </div>
            </div>
          </div>
            <div *ngIf="privilegesView==='VAMD'"  class="outside-container ">
                <div class="box-container ">
                    <div *ngIf="!ShowEdit" class="container ">
                      <div class="col-md-12 row d-flex justify-content-center " style="padding-left: 20px; ">
                     
                        
                       <div class="col-md-12" style="height:70vh; overflow-y: auto;">
                         <div *ngIf="showGroup" class="col-md-12 card" style="min-height: 100%;" >
    
                          <div class=" row mt-3 " style="padding: 10px;">
                           
                            
                            <div class="col-md-12 " >
                              <div class="row">
                              <mat-form-field class=" col-md-3 mt-1 form-group " >
                              <input matInput type="text"  [(ngModel)]="search.searchText"      placeholder="Search..." autocomplete="off" (input)="searchUser()"  >
                              
                              </mat-form-field>
                              <div  class="  col-md-1 pt-3">
                                  <button  class="btn btn-outline-primary btn-sm " (click)="onAddGroup()"><img src="assets/images/Add_24.png"></button>
                                 
                               </div>
                              <mat-paginator  class="col-md-8 mt-2 " style="background-color: transparent;" color="primary"
                              [pageSize]="10"
                              [pageSizeOptions]="[5, 10, 25, 100]"
                              [length]="totalElements"
                              (page)="nextPage($event)"
                              aria-label="Select page">
                              </mat-paginator>
                              
                              </div>
                              
                              <table mat-table
                              [dataSource]="groupData" multiTemplateDataRows style="background-color: transparent;">
                             
                              <!-- <ng-container matColumnDef="code">
                               <th mat-header-cell *matHeaderCellDef> Code </th>
                               <td mat-cell *matCellDef="let element;"> {{element.code}} </td>
                              </ng-container> -->
                               <ng-container matColumnDef="name">
                                 <th mat-header-cell *matHeaderCellDef>Policy</th>
                                 <td mat-cell *matCellDef="let element" > {{element.name}} </td>
                               </ng-container>
                               <ng-container matColumnDef="source">
                                  <th mat-header-cell *matHeaderCellDef>Type</th>
                                  <!-- <td mat-cell *matCellDef="let element" > {{sourceCodeToName(element.source)}} </td> -->
                                  <td mat-cell *matCellDef="let element" > {{'-'}} </td>

                                </ng-container>
    
                              <ng-container matColumnDef="status">
                               <th mat-header-cell *matHeaderCellDef> Status </th>
                               <td mat-cell *matCellDef="let element"> 
                                <span *ngIf="element.status==='A'">Active</span>
                                <span *ngIf="element.status==='I'">Inactive</span> </td>
                              </ng-container>
                              
                              <!-- email Column -->
                             
                              <ng-container matColumnDef="creationDate" >
                                <th mat-header-cell *matHeaderCellDef>Last Update</th>
                                <td mat-cell *matCellDef="let element"> {{formatDate(element.genTs)}} </td>
                               </ng-container>
  
                               <ng-container matColumnDef="delete" >
                                  <th mat-header-cell *matHeaderCellDef>Action </th>
                                  <td mat-cell *matCellDef="let element"> 
                                    <button mat-flat-button style="background-color: rgb(14, 115, 222);color: #fff;"  (click)="rowGroupClick(element)">Edit</button>
                                    <!-- <img (click)="deleteQueue(element.id)"  src="../../../assets/images/crosss.png" style="width: 25px;cursor: pointer;" alt=""> </td> -->
                                 </ng-container>
                             
                              <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
                              <ng-container matColumnDef="expandedDetail">
                              <td mat-cell *matCellDef="let element" [attr.colspan]="columnsGroupDisplay.length">
                              <div class="example-element-detail row"
                               [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                              
                              </div>
                              </td>
                              </ng-container>
                              
                              <tr mat-header-row *matHeaderRowDef="columnsGroupDisplay"></tr>
                              <tr mat-row *matRowDef="let element; columns: columnsGroupDisplay;"
                              class="example-element-row">
                              </tr>
                              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
                              <tr class="mat-row" *matNoDataRow>
                              <td  class="mat-cell" colspan="4">There is no data in this table</td>
                              </tr>
                              </table>
                              
                              
                              </div>
                              
                          
                        
                        </div> 
                          </div>
                          
                        </div>
                        </div>
                    </div>
    

                    


                    <div class="modal " id="myMod"  [style.display]="showGroupPopup ? 'block' : 'none'" >
                      <div class="modal-dialog" >
                          <div class="modal-content " >
                              <div class="modal-header title">
                                <h4 class="modal-title">Add Policy</h4>
                                <button type="button" class="close" data-dismiss="modal" (click)="closePopup()">&times;</button>
                                </div>
                                <div class="modal-body">
                                <div class="col-md-12 mt-3 " *ngIf="showGroupPopup">
                                  <div class="col-md-12 d-flex justify-content-center" >
                                  <div class="col-md-12 row " >
                                      <div class=" col-md-12 ">
                                          <form [formGroup]="policyRefFg"  autocomplete="off"  class=" row" >
                                            
                                            <mat-form-field class="col-md-12" appearance="outline">
                                              <mat-label>Policy Name</mat-label>
                                              <input matInput type="text" maxlength="30" formControlName="name" name="name" autocomplete="off">
                                              <small *ngIf="policyRefFg.controls['name'].dirty && policyRefFg.controls['name'].invalid" class="warn">Please Enter Queue name!</small>
    
                                            </mat-form-field>
                                            
                                           
                                            
                                            <mat-form-field class="col-md-12" appearance="outline">
                                              <mat-label>Status</mat-label>
                                              <mat-select matNativeControl name="status" formControlName="status">
                                                <mat-option value="A">Active</mat-option>
                                                <mat-option value="I">Inactive</mat-option>
                                              </mat-select>  
                                            </mat-form-field> 
                                            <mat-form-field class="col-md-12" appearance="outline">
                                                <mat-label>Description </mat-label>
                                                <textarea matInput type="text" maxlength="200" formControlName="description" name="name" autocomplete="off"></textarea>
      
                                              </mat-form-field>
                                            
                                            
                                            </form>
                                      </div>
                                      </div>
                                      </div>                                      
                                </div>
                                  <div class="modal-footer">
                                    <div class="form-group form-inline ">
                                      <label for="userName" class="col-md-5 col-form-label control-label"> </label>
                                    </div>   
                                    <button *ngIf="action==='newQue'" class="btn btn-outline-success c-width-100px shadow "  (click)="AddQueue()" [disabled]="policyRefFg.invalid">Save</button>
                                    <button type="button" class="btn btn-outline-primary c-width-100px shadow" data-dismiss="modal" (click)="closePopup()">Close</button>
                                  </div>
                                </div>
                                </div>
                        </div>
                    </div>






<div >
     
      <div *ngIf="ShowEdit" class="row col-md-12 d-flex justify-content-center ">
          <div *ngIf="!showClauses" class="  mb-4  col-md-11   ">


            <div class="alerts-container">
              <h1> Travel Policy - Default </h1>
              <div class="filters">
                <!-- <button *ngFor="let filter of filters" class="filter-button">{{ filter }}</button> -->
                <!-- <div class="col-md-3 pleft " >
                  <label  for="from">From</label>
                  <input  class="form-control font" type="datetime-local" [max]="maxDate" name="startDate" (change)="validateDates()"   [(ngModel)]="request.startDate">
                </div>
                <div class="col-md-3 pleft " >
                  <label  for="to">To </label>
                  <input  class="form-control font" type="datetime-local" [min]="request.startDate" [max]="maxSelectionDate" name="stopDate"  (change)="validateEndDates()"   [(ngModel)]="request.endDate">
                </div> -->
              </div>
            
              <div class="alert-list">
                <div  class="alert-item" >
                  <div class="alert-icon">
                   <mat-icon >flight</mat-icon>
                  </div>
                  <div class="alert-content">
                    <p class="alert-title"> Flight</p>
                    <p class="alert-info">Policies for Air Search & Air Booking</p>
                  </div>
                  <div class="alert-action">
                    <span (click)="onClickClauses()" class="arrow-icon">&rarr;</span>
                  </div>
                </div>
              </div>
              <div class="alert-list mt-1">
                <div  class="alert-item" >
                  <div class="alert-icon">
                   <mat-icon >hotel</mat-icon>
                  </div>
                  <div class="alert-content">
                    <p class="alert-title"> Hotel</p>
                    <p class="alert-info">Policies for Hotel Search & Hotel Booking</p>
                  </div>
                  <div class="alert-action">
                    <span class="arrow-icon">&rarr;</span>
                  </div>
                </div>
              </div>
              <!-- <div class="alert-list">
                <div  class="alert-item" >
                  <div class="alert-icon">
                   <mat-icon >car</mat-icon>
                  </div>
                  <div class="alert-content">
                    <p class="alert-title"> Car Rentals</p>
                    <p class="alert-info">All employees can book car rentals in the US and Canada</p>
                  </div>
                  <div class="alert-action">
                    <span class="arrow-icon">&rarr;</span>
                  </div>
                </div>
              </div> -->
            </div>

          
            
            
            <div class="approval-container">
              <h3>Approval workflows</h3>
              <p class="subtitle">
                Each policy can have its own approval workflow. You can add and remove approvers as needed.
              </p>
            
              <button class="add-approver-btn" (click)="addApprovers()">
                <span class="plus-icon">＋</span> Add approver
              </button>
            </div>
<div *ngIf="policyData?.length!=0">
            <table mat-table class="tablePlicy"
            [dataSource]="policyData" multiTemplateDataRows style="background-color: transparent;">
           
           
             <ng-container matColumnDef="name">
               <th mat-header-cell *matHeaderCellDef>Policy</th>
               <td mat-cell *matCellDef="let element" > {{element.workFlowName}} </td>
             </ng-container>
             <ng-container matColumnDef="source">
                <th mat-header-cell *matHeaderCellDef>Type</th>
                <!-- <td mat-cell *matCellDef="let element" > {{sourceCodeToName(element.source)}} </td> -->
                <td mat-cell *matCellDef="let element" > {{'-'}} </td>

              </ng-container>

            <ng-container matColumnDef="status">
             <th mat-header-cell *matHeaderCellDef> Status </th>
             <td mat-cell *matCellDef="let element"> 
              <span *ngIf="element.status==='A'">Active</span>
              <span *ngIf="element.status==='I'">Inactive</span> </td>
            </ng-container>
            
            <!-- email Column -->
           
            <ng-container matColumnDef="creationDate" >
              <th mat-header-cell *matHeaderCellDef>Description</th>
              <td mat-cell *matCellDef="let element"> {{element.workFlowDesc}} </td>
             </ng-container>

             <ng-container matColumnDef="delete" >
                <th mat-header-cell *matHeaderCellDef>Action </th>
                <td mat-cell *matCellDef="let element"> 
                  <button mat-flat-button style="background-color: rgb(14, 115, 222);color: #fff;"  (click)="rowPolicyClick(element)">Edit</button>
                  <!-- <img (click)="deleteQueue(element.id)"  src="../../../assets/images/crosss.png" style="width: 25px;cursor: pointer;" alt=""> </td> -->
               </ng-container>
           
            <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
            <!-- <ng-container matColumnDef="expandedDetails">
            <td mat-cell *matCellDef="let element" [attr.colspan]="columnsPolicyDisplay.length">
            <div class="example-element-detail row"
             [@detailExpand]="element == expandedPolicyElement ? 'expanded' : 'collapsed'">
            
            </div>
            </td>
            </ng-container> -->
            
            <tr mat-header-row *matHeaderRowDef="columnsPolicyDisplay"></tr>
            <tr mat-row *matRowDef="let element; columns: columnsPolicyDisplay;"
            class="example-element-row">
            </tr>
            <!-- <tr mat-row *matRowDef="let row; columns: ['expandedDetails']" class="example-detail-row"></tr> -->
            <tr class="mat-row" *matNoDataRow>
            <td  class="mat-cell" colspan="4">There is no data in this table</td>
            </tr>
            </table>

          </div>



            
                  
              <div   class="col-md-11 mleft d-flex justify-content-end">
              </div>
         
      </div>
      <div *ngIf="showClauses" class=" mb-4  col-md-11   ">

        <div class="alerts-container">
          <h1> Clauses </h1>
          <div class="alert-action">
            <span (click)="onBackCluaes()"  class="arrow-icon">&larr;</span>
          </div>
          <div class="filters">
            
          </div>
        
          <div *ngFor="let clause of clauseslist" class="alert-list">
            <div  class="alert-item" >
              <div class="alert-icon">
               <mat-icon >flight</mat-icon>
              </div>
              <div class="alert-content">
                <p class="alert-title"> {{clause.value}}</p>
                <p class="alert-info">{{clause.description}}</p>
              </div>
              <div class="alert-action">
                <span  class="arrow-icon">&rarr;</span>
              </div>
            </div>
          </div>
          <!-- <div class="alert-list mt-1">
            <div  class="alert-item" >
              <div class="alert-icon">
               <mat-icon >hotel</mat-icon>
              </div>
              <div class="alert-content">
                <p class="alert-title"> Advanced Booking</p>
                <p class="alert-info">Employees must book hotels at least 7 days in advance</p>
              </div>
              <div class="alert-action">
                <span class="arrow-icon">&rarr;</span>
              </div>
            </div>
          </div> -->
        </div>
      </div>
  </div>    
  </div>
 
  


  <p-dialog   [modal]="true" [maximizable]="true" [(visible)]="ShowCreateApproval" [style]="{ width: '80%' }">
    <ng-template pTemplate="header">
      <h2 *ngIf="actionApproval==='update'">Edit policy</h2>
      <h2 *ngIf="actionApproval!='update'">Create a new policy</h2>

    </ng-template>
    <div [formGroup]="policyForm"  class="containersss">
      <p class="description">
        Set up and manage approval workflows for travel policies, including adding approvers,
        setting up sequential or parallel approvals, and defining approval conditions.
      </p>
    
      <div class="form-group">
        <label>Name</label>
        <input formControlName="workFlowName"  />
      </div>
      <div class="form-group">
        <label>Description</label>
        <input formControlName="workFlowDesc"  />

      </div>
      <div class="section">
        <h3>Approval workflow</h3>
        <p>Choose your approval workflow.</p>
        <div class="workflow-options">
          <mat-radio-group
          [(ngModel)]="selectedWorkflow"
          [ngModelOptions]="{standalone: true}"
          class="workflow-options"
          name="workflow"
        >
          <mat-radio-button color="primary"
            *ngFor="let option of workflowOptions"
            [value]="option"
            class="workflow-option"
          >
            {{ option }}
          </mat-radio-button>
        </mat-radio-group>
        </div>
      </div>
      <div formArrayName="approvers" class="section">
        <h3>Approvers</h3>
        <p>You can add up to 10 approvers for each policy.</p>
        <button type="button" class="add-btn" (click)="addApprover()">+ Add approver</button>
      
        <div *ngFor="let approver of approvers.controls; let i = index" [formGroupName]="i" class="row">
          <div  class="col-md-4">
            <select formControlName="key" name="key">
              <option value="email">Approver Email</option>
              <option value="empCode">Approver Emp Code</option>
              <option value="manager">Approver Manager</option>
              <option value="profile">From Employee Profile</option>

            </select>
          </div>
        
          <div   class="col-md-4">
            <input *ngIf="approver.get('key')?.value !== 'manager' && approver.get('key')?.value !== 'profile'"  formControlName="value" placeholder="Approver {{ i + 1 }}" />
          </div>
          <div class="col-md-3">
<img src="../../../assets/images/crosss.png" style="width: 20px;height:20px;margin-top:4px" alt="" (click)="removeApprover(i)">
          </div>
        </div>
      </div>
      
    
    
    
      <div class="section">
        <h3>Approval conditions</h3>
        <p>You can create conditional approvals based on request attributes.</p>

        <h5 style="font-size: 18px;">Match All <button type="button" style="margin-left: 17px;" class="add-btn"  (click)="op.toggle($event);blank()">+ Add condition</button></h5>

        
       
    <p-overlayPanel #op>
      <div class="approval-form-container">
        <!-- First Dropdown -->
        <div class="form-group">
          <label>Type</label>
          <select
            name="one"
            [(ngModel)]="approvalCondition.one"
            (change)="onChangeAttribute()"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="Employee">Employee</option>
            <option value="Trip">Trip</option>
          </select>
        </div>
      
        <!-- ng-select dropdown -->
        <div class="form-group">
          <label>Variable</label>
          <ng-select
          class="changeAlt"
            [items]="approvalList"
            bindLabel="cityLabel"
            [(ngModel)]="selectedObject"
            [ngModelOptions]="{ standalone: true }"
            [searchable]="true"
            [virtualScroll]="true"
            (change)="selectedTo($event)"
          >
            <ng-template ng-option-tmp let-item="item">
              {{ item }}
            </ng-template>
          </ng-select>
        </div>
      
        <!-- Operator Dropdown -->
        <div class="form-group">
          <label>Operator</label>
          <select
            name="three"
            [(ngModel)]="approvalCondition.three"
            [ngModelOptions]="{ standalone: true }"
          >
            <option value="=">=</option>
            <option value="contains">contains</option>
            <option value=">">></option>
            <option value="<"><</option>
            <option value="is">is</option>
          </select>
        </div>
      
        <!-- Input Field -->
        <div class="form-group">
          <label>Value</label>
          <input
            type="text"
            [(ngModel)]="approvalCondition.four"
            [ngModelOptions]="{ standalone: true }"
            autocomplete="off"
          />
        </div>
      
        <!-- Save Button -->
        <div  class="form-actions">
          <button type="button" (click)="save(op)">Save</button>
        </div>
      </div>
      
      
    </p-overlayPanel>
           

        <div class="col-md-12">
          <div *ngIf="approvalSonditions.length!=0" class="tag-table-container row">
            
            <button
            *ngFor="let item of approvalSonditions; let i = index"
            class="tag-button col-md-3"
          >
            <span class="truncate-text">{{ item.attName }} {{ item.operator }} {{ item.value }}</span> <img src="../../../assets/images/crosss.png" style="width: 15px;height:15px;margin-top:4px;margin-left: 8px;" alt="" (click)="removeApproverC(i)">

          </button>
         
          </div>
        </div>

        <h5 class="mt-4" style="font-size: 18px;">Match Any         <button type="button" class="add-btn" style="margin-left: 10px;"  (click)="ops.toggle($event);blank()">+ Add condition</button>
        </h5>

       
        <p-overlayPanel #ops>
          <div class="approval-form-container">
            <!-- First Dropdown -->
            <div class="form-group">
              <label>Type</label>
              <select
                name="one"
                [(ngModel)]="approvalConditionAny.one"
                (change)="onChangeAttributeAny()"
                [ngModelOptions]="{ standalone: true }"
              >
                <option value="Employee">Employee</option>
                <option value="Trip">Trip</option>
              </select>
            </div>
          
            <!-- ng-select dropdown -->
            <div class="form-group">
              <label>Variable</label>
              <ng-select
              class="changeAlt"
                [items]="approvalList"
                bindLabel="cityLabel"
                [(ngModel)]="selectedObjectAny"
                [ngModelOptions]="{ standalone: true }"
                [searchable]="true"
                [virtualScroll]="true"
                (change)="selectedToAny($event)"
              >
                <ng-template ng-option-tmp let-item="item">
                  {{ item }}
                </ng-template>
              </ng-select>
            </div>
          
            <!-- Operator Dropdown -->
            <div class="form-group">
              <label>Operator</label>
              <select
                name="three"
                [(ngModel)]="approvalConditionAny.three"
                [ngModelOptions]="{ standalone: true }"
              >
                <option value="=">=</option>
                <option value="contains">contains</option>
                <option value=">">></option>
                <option value="<"><</option>
                <option value="is">is</option>
              </select>
            </div>
          
            <!-- Input Field -->
            <div class="form-group">
              <label>Value</label>
              <input
                type="text"
                [(ngModel)]="approvalConditionAny.four"
                [ngModelOptions]="{ standalone: true }"
                autocomplete="off"
              />
            </div>
          
            <!-- Save Button -->
            <div class="form-actions">
              <button type="button" (click)="saveAny(op)">Save</button>
            </div>
          </div>
          
          
        </p-overlayPanel>
               
    
            <div class="col-md-12">
              <div *ngIf="approvalSonditionsAny.length!=0" class="tag-table-container row">
                
                <button
                *ngFor="let item of approvalSonditionsAny; let i = index"
                class="tag-button col-md-3"
              >
                <span class="truncate-text">{{ item.attName }} {{ item.operator }} {{ item.value }}</span> <img src="../../../assets/images/crosss.png" style="width: 15px;height:15px;margin-top:4px;margin-left: 8px;" alt="" (click)="removeApproverCAny(i)">
    
              </button>
             
              </div>
            </div>

      </div>
      <button *ngIf="actionApproval==='update'" class="save-btn" (click)="UpdatePolicy()" [disabled]="disabled">Update policy</button>

      <button *ngIf="actionApproval!='update'" class="save-btn" (click)="AddPolicy()" [disabled]="disabled">Save policy</button>
    </div>
    
 
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end gap-2 mt-3">
<!--       
    
      <p-button  label="Accept"  />&nbsp;
      <p-button  label="Back to Search"    /> -->

  </div>
  
  </ng-template>
</p-dialog>
  
 
                   